module.exports = __webpack_public_path__ + "img/TeamComic_008.c5d5da79.png";